import React from 'react';
import Navbar from '../Components/NavBar/NavBar';
import Review from '../Components/Review/Review';
import Footer from '../Components/Footer/Footer';

function NewReview() {
  return (
    <div>
        <Navbar />
        <Review />
    </div>
  )
}

export default NewReview;